var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.Notification-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\r\n\t\t.Notification-st1 {\r\n\t\t\tdisplay: none;\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Notification-st0",
    d: "M8,16c-0.5,0-1-0.2-1.3-0.6l-0.8-1h4.3l-0.8,1C9,15.8,8.5,16,8,16z M13.5,13.5H2.5c-0.3,0-0.7-0.2-0.8-0.5 s-0.1-0.7,0.2-0.9l1-1V7c0-2.7,1.5-4.6,3.8-5.2V1.2C6.7,0.6,7.3,0,8,0c0.7,0,1.3,0.6,1.3,1.2v0.6c2.3,0.5,3.8,2.6,3.8,5.2v4.1l1,1 c0.2,0.2,0.3,0.6,0.2,0.9C14.2,13.3,13.9,13.5,13.5,13.5z M3.4,12.3h9.2l-0.7-0.7V7c0-2.1-1.1-3.6-2.9-4L8,2.8V1.2L8,1.2l0,1.5L7,3 C5.2,3.4,4.2,4.9,4.2,7v4.6L3.4,12.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Notification-st1",
    cx: 12.3,
    cy: 1.7,
    r: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.db145c29679f959378425229c69160fd.svg";
export { ForwardRef as ReactComponent };